// 用户相关接口
import request from '@/utils/request'
const preFixUrl = '/auth'
/**
 * 获取验证码
 * @param {*} params
 * @returns
 */
export const getCode = phone => {
  return request({
    url: `${preFixUrl}/getCheckCode?phone=${phone}`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}

//登录
export const userLogin = data => {
    return request({
      url: `${preFixUrl}/login`,
      method: 'post',
      headers: {
        ['Content-Type']: 'application/json'
      },
      data
    })
  }

//用户注册
  export const userRegister = data => {
    return request({
      url: `/bac/user/addUser`,
      method: 'post',
      headers: {
        ['Content-Type']: 'application/json'
      },
      data
    })
  }

